module.exports = __webpack_public_path__ + "img/ms.f6ae6787.png";